import './SelectIcon.css';

const iconList = [
  'academia-edu', 'airbnb', 'apple', 'bank', 'bear', 'bitcoin',
  'books-stack', 'card', 'chatgpt', 'codepen', 'coins', 'connection',
  'discord', 'doge', 'evernote', 'facebook', 'figma', 'flickr',
  'gag', 'generative', 'github', 'gitlab', 'gmail', 'google-drive',
  'google-play', 'icloud', 'instagram', 'kakao-talk', 'laptop', 'line',
  'linkedin', 'medium', 'mysql', 'netflix', 'oracle', 'paypal',
  'photos', 'quora', 'reddit', 'rss', 'safari', 'shark',
  'skype', 'slack', 'snapchat', 'social', 'soundcloud', 'spotify',
  'starbucks', 'steam', 'telegram', 'tumblr', 'twitch', 'twitter',
  'twitter-x', 'uber', 'viber', 'vimeo', 'wattpad', 'waze',
  'wechat', 'whatsapp', 'wordpress-logo', 'xing-logo', 'yahoo', 'yelp',
  'youtube'
];

export default function SelectIcon({ isOpen, selectedIcon, onSelect, onCancel }) {
  if (!isOpen) return null;

  const handleSelectIcon = (iconName) => {
    onSelect(`/images/totp/item-icon/${iconName}.png`);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="select-icon-overlay" onClick={handleOverlayClick}>
      <div className="select-icon-popup">
        <div className="select-icon-header">
          <span>아이콘을 선택 하세요.</span>
          <button className="select-icon-close" onClick={onCancel}>✕</button>
        </div>
        <div className="select-icon-content">
          <div className="icon-grid">
            {iconList.map((iconName) => {
              const iconPath = `/images/totp/item-icon/${iconName}.png`;
              const isSelected = selectedIcon === iconPath;
              return (
                <div
                  key={iconName}
                  className={`icon-item ${isSelected ? 'selected' : ''}`}
                  onClick={() => handleSelectIcon(iconName)}
                >
                  <img src={`${process.env.PUBLIC_URL}${iconPath}`} alt={iconName} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}